import React from 'react'
import { IonActionSheet } from '@ionic/react'
import { MessageType } from '../../components/WechatyMessage/interface'
import './index.css'
interface SelectMessageType {
    onSelected: (s: MessageType) => void
    label: string
}

const SelectMessage: React.FC<SelectMessageType> = (props) => {
    const [showActionSheet, setShowActionSheet] = React.useState(false)
    return (
        <div>
            <div
                className='selectMessageBtn'
                onClick={() => setShowActionSheet(true)}
            >
                {props.label}
            </div>
            <IonActionSheet
                isOpen={showActionSheet}
                onDidDismiss={() => setShowActionSheet(false)}
                buttons={[
                    {
                        text: '文字',
                        handler: () => {
                            props.onSelected(MessageType.TEXT)
                        },
                    },
                    {
                        text: '图片',
                        handler: () => {
                            props.onSelected(MessageType.IMAGE)
                        },
                    },
                ]}
            />
        </div>
    )
}

export default SelectMessage
